/* ------------------------------------------------------------------------ */
/*		File: cmpPolicy.tsx                                                 */
/*		Description: Component Implementation                               */
/*		Project: iSymWebSchool											    */
/*		Author: ISym Global Solutions Limited                               */
/*		Version: 1.0													    */
/* ------------------------------------------------------------------------ */

/* eslint-disable react/jsx-pascal-case */

import React, { ReactElement } from "react";
import { ICard, ICmpPolicy, TTypeItem } from "./cmpPolicy.d";
import { getImage } from "../GenericComponents/functions";
import "./cmpPolicy.css";
import Meta from "../GenericComponents/meta";

/* ------------------------------------------------------------------------ */

const Policy: React.FC<ICard> = ({ card }) => {

    const setElement = (item: ICmpPolicy): ReactElement => {
        switch(item.type?.toLowerCase()){
            case TTypeItem.BULLET:
                return (
                    <div className="card_policy_item">
                        <div className="card_policy_bullet" />
                        <div 
                            className="card_policy_description"
                            dangerouslySetInnerHTML={{ __html: item.description! }}
                        />
                    </div>
                );

            case TTypeItem.PARAGRAPH:
                return (
                    <div className="card_policy_item">
                        <div 
                            className="card_policy_paragraph"
                            dangerouslySetInnerHTML={{ __html: item.description! }}
                        />
                    </div>
                );

            case TTypeItem.IMAGE:
                return (
                    <div className="card_policy_item">
                        <div className="card_policy_image">
                            <img src={getImage(item.src)} alt={item.src} />
                        </div>
                        <div 
                            className="card_policy_description"
                            dangerouslySetInnerHTML={{ __html: item.description! }}
                        />
                    </div>
                );
            default:
                return (
                    <div className="card_policy_item">
                        <div 
                            className="card_policy_description"
                            dangerouslySetInnerHTML={{ __html: item.description! }}
                        />
                    </div>
                );
        }
    };

    const setGroup = (content: ICmpPolicy[]): ReactElement[] => {
        return content.map((item, index) => {
            if (item.type?.toLowerCase() === TTypeItem.GROUP) {
                return (
                    <div key={`group-${index}`} className="card_policy_group">
                        {setGroup(item.content!)}
                    </div>
                );
            } else {
                return (
                    <div key={`item-${index}`} className="card_policy_item">
                        {setElement(item)}
                    </div>
                );
            }
        });
    };

    return (
        <div className="card_policy">
            <Meta page={"refund"} />
            <div className="card_policy_title">{card.label}</div>
            <div className="card_policy_content scrollbar-thin scrollbar-thumb-rounded">
                <div 
                    className="card_policy_description"
                    dangerouslySetInnerHTML={{ __html: card.description! }}    
                />
                {card.content !== null && card.content?.map((item, index) => (
                    <div
                        key={`content-${index}`}
                        className="card_policy_group"
                    >
                        <div className="card_policy_label">{item.label}</div>
                        {item.description !== null && (
                            <div className="card_policy_description">{item.description}</div>
                        )}
                        {item.content !== null && setGroup(item.content!)}
                    </div>
                ))}
            </div>
        </div>
    );
};

export default Policy;
